import {
  AUTH_HIDE_VERIFICATION_MODAL,
  AUTH_SHOW_VERIFICATION_MODAL,
  CLEAR_VERIFICATION_QUEUE,
  PUSH_POST_VERIFICATION_QUEUE_ITEM,
} from '../actionTypes'

export const requireVerification = () => {
  return { type: AUTH_SHOW_VERIFICATION_MODAL }
}

export const hideVerificationModal = () => {
  return { type: AUTH_HIDE_VERIFICATION_MODAL }
}

export const clearVerificationQueue = () => ({
  type: CLEAR_VERIFICATION_QUEUE,
})

export const pushVerificationQueueItem = item => ({
  type: PUSH_POST_VERIFICATION_QUEUE_ITEM,
  item,
})

// Note: Because this action creator returns a function (not an action object),
// it will not work properly unless your redux store is configured with
// redux-thunk middleware.
// (See https://github.com/reduxjs/redux-thunk#motivation)
export const processPostVerificationQueue = () => (dispatch, getState) => {
  getState().verificationModalReducer.postVerificationQueue.forEach(item => {
    const [func, argsArray] = item
    func.apply(null, argsArray)
  })
  dispatch(clearVerificationQueue())
}
